import React from "react";
import { GridIcon, ArrowRightIcon, ArrowLeftIcon } from "../../common/Icons"; // Changed ListBulletIcon to GridIcon
import { MobileBottomNavProps } from "../../common/types";

const MobileBottomNav: React.FC<MobileBottomNavProps> = ({
  onMenuClick,
  onNextClick,
  onBackClick,
  isBackDisabled,
}) => {
  const buttonBaseClasses =
    "flex flex-col items-center justify-center pt-2 pb-[13px] px-2 transition-all w-1/3 h-full"; // Changed p-2 to pt-2 pb-[13px] px-2

  // Specific gradients for each button
  const backButtonGradient = "bg-gradient-to-b from-[#1175b7] to-[#0c5c9c]";
  const allItemsButtonGradient = "bg-gradient-to-b from-[#0f6bac] to-[#0a568e]";
  const nextButtonGradient = "bg-gradient-to-b from-[#1175b7] to-[#0c5c9c]";

  const enabledTextIconColor = "text-white";
  const disabledTextIconColor = "text-white cursor-not-allowed"; // Disabled text/icon remains white, cursor indicates disabled state

  return (
    <nav
      className={`md:hidden fixed bottom-0 left-0 right-0 bg-[#09517d] border-t border-[#084a6f] shadow-top-md z-50 flex items-center justify-around 
                   h-[calc(4rem+env(safe-area-inset-bottom))] pb-[env(safe-area-inset-bottom)]`}
      style={{
        boxShadow:
          "0 -4px 6px -1px rgba(0, 0, 0, 0.1), 0 -2px 4px -1px rgba(0, 0, 0, 0.06)",
      }} // Custom shadow for top
    >
      <button
        onClick={!isBackDisabled ? onBackClick : undefined}
        className={`${buttonBaseClasses} ${backButtonGradient} ${
          !isBackDisabled ? "hover:opacity-90" : ""
        }`}
        aria-label="Previous step"
        disabled={isBackDisabled}
      >
        <ArrowLeftIcon
          className={`w-6 h-6 mb-0.5 ${
            isBackDisabled ? disabledTextIconColor : enabledTextIconColor
          }`}
        />
        <span
          className={`text-base font-semibold whitespace-nowrap ${
            isBackDisabled ? disabledTextIconColor : enabledTextIconColor
          }`}
        >
          Back
        </span>
      </button>
      <div
        className={`h-full border-l ${
          isBackDisabled ? "border-white/20" : "border-white/30"
        }`}
      ></div>{" "}
      {/* Adjusted separator for context */}
      <button
        onClick={onMenuClick}
        className={`${buttonBaseClasses} ${allItemsButtonGradient} hover:opacity-90`}
        aria-label="Open navigation menu"
      >
        <GridIcon className={`w-6 h-6 mb-0.5 ${enabledTextIconColor}`} />
        <span
          className={`text-base font-semibold whitespace-nowrap ${enabledTextIconColor}`}
        >
          All Items
        </span>
      </button>
      <div className="h-full border-l border-white/30"></div>{" "}
      {/* Vertical separator */}
      <button
        onClick={onNextClick}
        className={`${buttonBaseClasses} ${nextButtonGradient} hover:opacity-90`}
        aria-label="Next step"
      >
        <ArrowRightIcon className={`w-6 h-6 mb-0.5 ${enabledTextIconColor}`} />
        <span
          className={`text-base font-semibold whitespace-nowrap ${enabledTextIconColor}`}
        >
          Next
        </span>
      </button>
    </nav>
  );
};

export default MobileBottomNav;
